// Master Data for Habit Tracker - All Local, No Firebase Dependencies

export const HABIT_ICONS = {
  // Water & Hydration
  "water-drop": { emoji: "💧", name: "Water Drop", category: "health", tags: ["water", "hydration", "drink"] },
  "water-glass": { emoji: "🥛", name: "Glass", category: "health", tags: ["water", "drink", "glass"] },
  "bottle": { emoji: "🍼", name: "Bottle", category: "health", tags: ["water", "bottle", "drink"] },
  
  // Exercise & Fitness
  "dumbbell": { emoji: "🏋️", name: "Dumbbell", category: "fitness", tags: ["exercise", "gym", "strength"] },
  "running": { emoji: "🏃", name: "Running", category: "fitness", tags: ["run", "cardio", "exercise"] },
  "walking": { emoji: "🚶", name: "Walking", category: "fitness", tags: ["walk", "steps", "exercise"] },
  "bicycle": { emoji: "🚴", name: "Bicycle", category: "fitness", tags: ["bike", "cycling", "cardio"] },
  "swimming": { emoji: "🏊", name: "Swimming", category: "fitness", tags: ["swim", "pool", "water"] },
  "yoga": { emoji: "🧘", name: "Yoga", category: "fitness", tags: ["yoga", "meditation", "stretch"] },
  
  // Food & Nutrition
  "apple": { emoji: "🍎", name: "Apple", category: "nutrition", tags: ["fruit", "healthy", "food"] },
  "salad": { emoji: "🥗", name: "Salad", category: "nutrition", tags: ["vegetables", "healthy", "green"] },
  "carrot": { emoji: "🥕", name: "Carrot", category: "nutrition", tags: ["vegetable", "healthy", "orange"] },
  "avocado": { emoji: "🥑", name: "Avocado", category: "nutrition", tags: ["fruit", "healthy", "green"] },
  
  // Sleep & Rest
  "bed": { emoji: "🛏️", name: "Bed", category: "wellness", tags: ["sleep", "rest", "bed"] },
  "moon": { emoji: "🌙", name: "Moon", category: "wellness", tags: ["sleep", "night", "rest"] },
  "pillow": { emoji: "🛏️", name: "Pillow", category: "wellness", tags: ["sleep", "comfort", "rest"] },
  
  // Learning & Growth
  "book": { emoji: "📖", name: "Book", category: "learning", tags: ["read", "study", "knowledge"] },
  "writing": { emoji: "✍️", name: "Writing", category: "learning", tags: ["write", "journal", "notes"] },
  "brain": { emoji: "🧠", name: "Brain", category: "learning", tags: ["think", "learn", "mental"] },
  "lightbulb": { emoji: "💡", name: "Light Bulb", category: "learning", tags: ["idea", "creative", "inspiration"] },
  
  // Productivity & Work
  "computer": { emoji: "💻", name: "Computer", category: "productivity", tags: ["work", "code", "tech"] },
  "clock": { emoji: "⏰", name: "Clock", category: "productivity", tags: ["time", "schedule", "punctual"] },
  "target": { emoji: "🎯", name: "Target", category: "productivity", tags: ["goal", "focus", "aim"] },
  "checkmark": { emoji: "✅", name: "Checkmark", category: "productivity", tags: ["done", "complete", "task"] },
  
  // Social & Relationships
  "heart": { emoji: "❤️", name: "Heart", category: "social", tags: ["love", "care", "emotion"] },
  "phone": { emoji: "📞", name: "Phone", category: "social", tags: ["call", "contact", "communication"] },
  "family": { emoji: "👨‍👩‍👧‍👦", name: "Family", category: "social", tags: ["family", "together", "love"] },
  
  // Mindfulness & Wellness
  "lotus": { emoji: "🪷", name: "Lotus", category: "wellness", tags: ["meditation", "peace", "mindful"] },
  "sun": { emoji: "☀️", name: "Sun", category: "wellness", tags: ["morning", "energy", "positive"] },
  "sparkles": { emoji: "✨", name: "Sparkles", category: "wellness", tags: ["magic", "positive", "energy"] }
};

export const HABIT_CATEGORIES = [
  { key: "health", label: "Health", iconId: "water-drop", colorId: "blue" },
  { key: "fitness", label: "Fitness", iconId: "dumbbell", colorId: "orange" },
  { key: "nutrition", label: "Nutrition", iconId: "apple", colorId: "green" },
  { key: "wellness", label: "Wellness", iconId: "lotus", colorId: "purple" },
  { key: "learning", label: "Learning", iconId: "book", colorId: "indigo" },
  { key: "productivity", label: "Productivity", iconId: "target", colorId: "red" },
  { key: "social", label: "Social", iconId: "heart", colorId: "pink" },
  { key: "other", label: "Other", iconId: "sparkles", colorId: "gray" }
];

export const HABIT_COLORS = [
  { id: "blue", name: "Ocean Blue", value: "#1E90FF", category: "cool" },
  { id: "green", name: "Forest Green", value: "#52c41a", category: "nature" },
  { id: "orange", name: "Sunset Orange", value: "#fa8c16", category: "warm" },
  { id: "purple", name: "Royal Purple", value: "#722ed1", category: "cool" },
  { id: "red", name: "Energy Red", value: "#f5222d", category: "warm" },
  { id: "pink", name: "Rose Pink", value: "#eb2f96", category: "warm" },
  { id: "indigo", name: "Deep Indigo", value: "#2f54eb", category: "cool" },
  { id: "teal", name: "Ocean Teal", value: "#13c2c2", category: "cool" },
  { id: "lime", name: "Fresh Lime", value: "#a0d911", category: "nature" },
  { id: "amber", name: "Golden Amber", value: "#faad14", category: "warm" },
  { id: "cyan", name: "Sky Cyan", value: "#1890ff", category: "cool" },
  { id: "gray", name: "Neutral Gray", value: "#8c8c8c", category: "neutral" }
];

export const HABIT_FREQUENCIES = [
  { value: "daily", label: "Every Day", description: "Perform this habit daily" },
  { value: "weekdays", label: "Weekdays Only", description: "Monday through Friday" },
  { value: "weekends", label: "Weekends Only", description: "Saturday and Sunday" },
  { value: "weekly", label: "Weekly", description: "Once per week" },
  { value: "custom", label: "Custom Schedule", description: "Set your own schedule" }
];

export const HABIT_TEMPLATES = [
  // Health & Hydration
  {
    id: "drink-water",
    name: "Drink 8 Glasses of Water",
    description: "Stay hydrated throughout the day",
    iconId: "water-drop",
    category: "health",
    colorId: "blue",
    frequency: "daily",
    isQuantifiable: true,
    targetCount: 8,
    difficulty: 2
  },
  {
    id: "morning-water",
    name: "Morning Glass of Water",
    description: "Start your day with hydration",
    iconId: "water-glass",
    category: "health", 
    colorId: "blue",
    frequency: "daily",
    isQuantifiable: false,
    targetCount: 1,
    difficulty: 1
  },
  
  // Fitness & Exercise
  {
    id: "daily-walk",
    name: "30 Minute Walk",
    description: "Take a refreshing walk outdoors",
    iconId: "walking",
    category: "fitness",
    colorId: "green",
    frequency: "daily",
    isQuantifiable: false,
    targetCount: 1,
    difficulty: 2
  },
  {
    id: "workout",
    name: "45 Minute Workout",
    description: "Complete a full body workout session",
    iconId: "dumbbell",
    category: "fitness",
    colorId: "orange",
    frequency: "daily",
    isQuantifiable: false,
    targetCount: 1,
    difficulty: 4
  },
  {
    id: "steps",
    name: "10,000 Steps Daily",
    description: "Track your daily step count",
    iconId: "running",
    category: "fitness",
    colorId: "orange",
    frequency: "daily",
    isQuantifiable: true,
    targetCount: 10000,
    difficulty: 3
  },
  
  // Nutrition
  {
    id: "eat-fruit",
    name: "Eat 3 Fruits Daily",
    description: "Include fresh fruits in your diet",
    iconId: "apple",
    category: "nutrition",
    colorId: "green",
    frequency: "daily",
    isQuantifiable: true,
    targetCount: 3,
    difficulty: 2
  },
  {
    id: "healthy-breakfast",
    name: "Eat Healthy Breakfast",
    description: "Start your day with nutritious food",
    iconId: "avocado",
    category: "nutrition",
    colorId: "green",
    frequency: "daily",
    isQuantifiable: false,
    targetCount: 1,
    difficulty: 2
  },
  
  // Learning & Growth
  {
    id: "read-daily",
    name: "Read 30 Minutes",
    description: "Dedicate time to reading books",
    iconId: "book",
    category: "learning",
    colorId: "indigo",
    frequency: "daily",
    isQuantifiable: false,
    targetCount: 1,
    difficulty: 2
  },
  {
    id: "journal",
    name: "Write in Journal",
    description: "Reflect and write daily thoughts",
    iconId: "writing",
    category: "learning",
    colorId: "purple",
    frequency: "daily",
    isQuantifiable: false,
    targetCount: 1,
    difficulty: 2
  },
  
  // Wellness & Mindfulness
  {
    id: "meditate",
    name: "Meditate 10 Minutes",
    description: "Practice mindfulness and meditation",
    iconId: "lotus",
    category: "wellness",
    colorId: "purple",
    frequency: "daily",
    isQuantifiable: false,
    targetCount: 1,
    difficulty: 2
  },
  {
    id: "sleep-early",
    name: "Sleep Before 10 PM",
    description: "Maintain a healthy sleep schedule",
    iconId: "bed",
    category: "wellness",
    colorId: "indigo",
    frequency: "daily",
    isQuantifiable: false,
    targetCount: 1,
    difficulty: 3
  },
  
  // Productivity
  {
    id: "plan-day",
    name: "Plan Tomorrow",
    description: "Organize and plan the next day",
    iconId: "target",
    category: "productivity",
    colorId: "red",
    frequency: "daily",
    isQuantifiable: false,
    targetCount: 1,
    difficulty: 2
  },
  {
    id: "no-phone-morning",
    name: "No Phone First Hour",
    description: "Start day without checking phone",
    iconId: "sun",
    category: "wellness",
    colorId: "amber",
    frequency: "daily",
    isQuantifiable: false,
    targetCount: 1,
    difficulty: 4
  },
  
  // Social & Relationships
  {
    id: "call-family",
    name: "Call Family Member",
    description: "Stay connected with loved ones",
    iconId: "phone",
    category: "social",
    colorId: "pink",
    frequency: "daily",
    isQuantifiable: false,
    targetCount: 1,
    difficulty: 1
  },
  {
    id: "gratitude",
    name: "Practice Gratitude",
    description: "Think of 3 things you're grateful for",
    iconId: "heart",
    category: "wellness",
    colorId: "pink",
    frequency: "daily",
    isQuantifiable: false,
    targetCount: 1,
    difficulty: 1
  },
  
  // Creative & Fun
  {
    id: "creative-time",
    name: "30 Minutes Creative Time",
    description: "Engage in creative activities",
    iconId: "lightbulb",
    category: "learning",
    colorId: "amber",
    frequency: "daily",
    isQuantifiable: false,
    targetCount: 1,
    difficulty: 2
  }
];

// Helper functions for lookups
export const lookupIcon = (iconId) => {
  return HABIT_ICONS[iconId] || { emoji: '✅', name: 'Default' };
};

export const lookupColor = (colorId) => {
  const color = HABIT_COLORS.find(c => c.id === colorId);
  return color ? color.value : '#1E90FF';
};

export const lookupCategory = (categoryKey) => {
  const category = HABIT_CATEGORIES.find(c => c.key === categoryKey);
  if (!category) {
    return { key: 'other', label: 'Other', icon: '🌟', color: '#8c8c8c' };
  }
  
  const iconData = HABIT_ICONS[category.iconId];
  const colorData = HABIT_COLORS.find(c => c.id === category.colorId);
  
  return {
    key: category.key,
    label: category.label,
    icon: iconData ? iconData.emoji : '🌟',
    color: colorData ? colorData.value : '#8c8c8c'
  };
};

export const getTemplatesByCategory = (categoryKey) => {
  if (categoryKey === 'all') return HABIT_TEMPLATES;
  return HABIT_TEMPLATES.filter(template => template.category === categoryKey);
}; 